const activeClasses = ['bg-brand-900', 'text-white', 'shadow-sm'];
const inactiveClasses = ['text-slate-600'];
let cacheListenerBound = false;

function bindCacheReset() {
  if (cacheListenerBound) return;

  document.addEventListener('turbo:before-cache', () => {
    document.querySelectorAll('[data-public-product-story]').forEach(story => {
      delete story.dataset.productStoryBound;
    });
  });
  cacheListenerBound = true;
}

export function initPublicProductStory(root = document) {
  bindCacheReset();

  root.querySelectorAll('[data-public-product-story]').forEach(story => {
    if (story.dataset.productStoryBound === 'true') return;
    story.dataset.productStoryBound = 'true';
    const tabs = [...story.querySelectorAll('[data-public-product-story-tab]')];
    const panels = [...story.querySelectorAll('[data-public-product-story-panel]')];
    const animation = story.querySelector('[data-request-to-invoice-animation]');

    if (animation && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      animation.src = animation.dataset.animationSrc;
    }

    const select = key => {
      tabs.forEach(tab => {
        const active = tab.dataset.publicProductStoryTab === key;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle(activeClasses[0], active);
        tab.classList.toggle(activeClasses[1], active);
        tab.classList.toggle(activeClasses[2], active);
        tab.classList.toggle(inactiveClasses[0], !active);
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.publicProductStoryPanel !== key; });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab.dataset.publicProductStoryTab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        select(tabs[nextIndex].dataset.publicProductStoryTab);
      });
    });

    select(tabs.find(tab => tab.getAttribute('aria-selected') === 'true')?.dataset.publicProductStoryTab || tabs[0]?.dataset.publicProductStoryTab);
  });
}
